import './index.scss'
$("header .nav a").eq(3).addClass("active")